<xemex-dialog-shell
  [title]="'installations.editor.addPoints.title' | translate"
  [subtitle]="'installations.editor.addPoints.lead' | translate"
>
  <div class="flex flex-col gap-4">
    <xemex-search-input
      [placeholder]="'installations.editor.addPoints.searchPlaceholder' | translate"
      (valueChange)="query.set($event)"
    />

    <div
      class="add-points__list flex flex-col gap-1"
      [class.add-points__list--with-message]="!!refusalKey()"
    >
      @for (group of groups(); track group.key) {
        <section class="flex flex-col">
          <div class="flex items-center gap-2 rounded-md bg-surface-page px-2 py-1">
            <button
              type="button"
              class="add-points__toggle flex items-center text-text-secondary"
              [attr.aria-label]="group.label"
              [attr.aria-expanded]="group.expanded"
              (click)="toggleExpanded(group.key)"
            >
              <mat-icon>{{ group.expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
            </button>
            <mat-checkbox
              [aria-label]="group.label"
              [checked]="group.allChecked"
              [indeterminate]="group.someChecked"
              [disabled]="group.available === 0 || isSaving()"
              (change)="toggleCategory(group)"
            />
            <mat-icon class="text-brand-primary">{{ group.icon }}</mat-icon>
            <span class="font-semibold text-text-default">{{ group.label }}</span>
            <span class="ml-auto shrink-0 whitespace-nowrap text-xs text-text-secondary">
              {{
                'installations.editor.addPoints.available' | translate: { count: group.available }
              }}
            </span>
          </div>

          @if (group.expanded) {
            @for (row of group.rows; track row.role) {
              <div
                class="add-points__row flex items-center gap-2 border-b border-border-default px-2"
              >
                <mat-checkbox
                  [checked]="row.added || row.checked"
                  [disabled]="row.added || isSaving()"
                  (change)="toggleRole(row.role)"
                >
                  <span [class]="row.added ? 'text-text-disabled' : 'text-text-default'">
                    {{ row.label }}
                  </span>
                  <span
                    class="ml-1 text-xs"
                    [class]="row.added ? 'text-text-disabled' : 'text-text-secondary'"
                  >
                    {{ row.unit }}
                  </span>
                </mat-checkbox>
                @if (row.added) {
                  <span class="ml-auto shrink-0 whitespace-nowrap text-xs text-text-secondary">
                    {{ 'installations.editor.addPoints.alreadyAdded' | translate }}
                  </span>
                }
              </div>
            }
          }
        </section>
      } @empty {
        <p class="m-0 px-2 py-6 text-center text-sm text-text-muted">
          {{ 'installations.editor.addPoints.noMatches' | translate }}
        </p>
      }
    </div>

    @if (refusalKey(); as messageKey) {
      <p class="m-0 text-text-error" role="alert">{{ messageKey | translate }}</p>
    }
  </div>

  <div actions class="flex w-full items-center gap-3">
    <span class="mr-auto text-sm font-semibold text-text-secondary">
      {{ selectedKey() | translate: { count: selectedCount() } }}
    </span>
    <xemex-text-button (click)="cancel()">
      {{ 'general.btnCancel' | translate }}
    </xemex-text-button>
    <xemex-filled-button icon="add" [disabled]="!canSave()" [loading]="isSaving()" (click)="save()">
      {{ addKey() | translate: { count: selectedCount() } }}
    </xemex-filled-button>
  </div>
</xemex-dialog-shell>
